import { ABISSAL } from "./abissal";
import { ESPUMA } from "./espuma";
import { OCEANO } from "./oceano";
import { RECIFE } from "./recife";
import type { PresetDefinition, PresetId } from "./types";

export { TYPUS_COLOURS } from "./oceano";
export { extendPreset, PRESET_IDS } from "./types";
export type { PresetDefinition, PresetId } from "./types";
export { ABISSAL, ESPUMA, OCEANO, RECIFE };

/**
 * All built-in presets by id
 */
export const PRESETS: Record<PresetId, PresetDefinition> = {
  oceano: OCEANO,
  recife: RECIFE,
  abissal: ABISSAL,
  espuma: ESPUMA,
};
